import React, { useEffect, useState } from 'react';
import { NavBar, Form, Input, Button, Toast, TextArea, SearchBar, List, Popup } from 'antd-mobile';
import { useLocation, useNavigate } from 'react-router-dom';
import '../styles/TransferApplyPage.css';
import { applyTransfer, listAllUser } from '../componet/service';

const TransferApplyPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { record } = location.state || {};
    const [loading, setLoading] = useState(false);
    const [userOptions, setUserOptions] = useState([]);
    const [filteredUsers, setFilteredUsers] = useState([]);
    const [form] = Form.useForm();
    const [visible, setVisible] = useState(false);
    const [searchValue, setSearchValue] = useState('');
    const [fieldName, setFieldName] = useState('');

    useEffect(() => {
        loadUser();
    }, []);
    if (!record) {
        return (
            <div className="transfer-apply-container">
                <NavBar back="返回" onBack={() => navigate(-1)}>
                    申请转移
                </NavBar>
                <div className="error-message">记录不存在或已被删除</div>
            </div>
        );
    }
    const loadUser = async () => {
        const res = await listAllUser();
        if (res.data) {
            const data = res.data;
            setUserOptions(data);
            setFilteredUsers(data);
        }
    }

    // 处理搜索
    const handleSearch = (value) => {
        setSearchValue(value);
        if (!value) {
            setFilteredUsers(userOptions);
        } else {
            const filtered = userOptions.filter(user =>
                user.name.toLowerCase().includes(value.toLowerCase())
            );
            setFilteredUsers(filtered);
        }
    };
    // 选择用户
    const selectUser = (user) => {
        console.dir(user);
        const fv = {};
        fv[fieldName] = user.id;
        form.setFieldsValue(fv);
        setVisible(false);
    };

    // 获取当前选中的用户名
    const getBorrowerName = () => {
        const userId = form.getFieldValue('targetBorrowerId');
        if (!userId) return '请选择转移人';
        const user = userOptions.find(u => u.id === userId);
        return user ? user.name : '请选择转移人';
    };

    const getRelatedUserName = () => {
        const userId = form.getFieldValue('targetRelatedUserId');
        if (!userId) return '请选择关系人';
        const user = userOptions.find(u => u.id === userId);
        return user ? user.name : '请选择关系人';
    };

    const onFinish = async (values) => {
        setLoading(true);
        try {
            // 这里替换为实际的API调用
            // await applyTransfer(record.id, values);
            const res = await applyTransfer(record.id, values.targetBorrowerId, values.targetRelatedUserId, values.reason);
            if (res.code === 0) {
                Toast.show({
                    icon: 'success',
                    content: '申请转移成功',
                });
                navigate(-2);
            } else {
                Toast.show({
                    icon: 'fail',
                    content: res.msg,
                })
            }
        } catch (error) {
            Toast.show({
                icon: 'fail',
                content: '申请失败，请重试',
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="transfer-apply-container">
            <NavBar back="返回" onBack={() => navigate(-1)}>
                申请转移
            </NavBar>

            <div className="device-info">
                <div className="device-name">{record.deviceName}</div>
                <div className="device-asset">资产编号: {record.assetNo}</div>
            </div>

            <Form
                form={form}
                layout="vertical"
                onFinish={onFinish}
                footer={
                    <Button block type="submit" color="primary" loading={loading}>
                        提交申请
                    </Button>
                }
            >
                <Form.Header>转移信息</Form.Header>

                <Form.Item
                    name="targetBorrowerId"
                    label="转移给"
                    rules={[{ required: true, message: '请输入接收人姓名' }]}
                >
                    <Button
                        onClick={() => {
                            setFieldName('targetBorrowerId');
                            setSearchValue('');
                            setFilteredUsers(userOptions);
                            setVisible(true);
                        }}
                        fill="none"
                        className="picker-button"
                    >
                        {getBorrowerName()}
                    </Button>
                </Form.Item>
                <Form.Item
                    name="targetRelatedUserId"
                    label="关系人"
                    rules={[{ required: true, message: '请选择关系人' },
                    ({ getFieldValue }) => ({
                        validator(_, value) {
                            if (!value || getFieldValue('targetBorrowerId') !== value) {
                                return Promise.resolve();
                            }
                            return Promise.reject(new Error('关系人不能与转移人相同'));
                        },
                    })]}
                >
                    <Button
                        onClick={() => {
                            setFieldName('targetRelatedUserId');
                            setSearchValue('');
                            setFilteredUsers(userOptions);
                            setVisible(true);
                        }}
                        fill="none"
                        className="picker-button"
                    >
                        {getRelatedUserName()}
                    </Button>
                </Form.Item>

                <Form.Item
                    name="reason"
                    label="转移原因"
                    // rules={[{ required: true, message: '请输入转移原因' }]}
                >
                    <TextArea
                        placeholder="请简要说明转移原因"
                        rows={4}
                        maxLength={200}
                        showCount
                    />
                </Form.Item>
            </Form>
            <Popup
                visible={visible}
                onMaskClick={() => setVisible(false)}
                position="bottom"
                bodyStyle={{ height: '60vh' }}
            >
                <div className="user-picker-popup">
                    <SearchBar
                        placeholder="搜索人员"
                        value={searchValue}
                        onChange={handleSearch}
                        style={{ padding: '8px' }}
                    />
                    <List style={{ maxHeight: 'calc(60vh - 56px)', overflow: 'auto' }}>
                        {filteredUsers.map(user => (
                            <List.Item
                                key={user.id}
                                onClick={() => selectUser(user)}
                                arrow={false}
                            >
                                {user.name}
                            </List.Item>
                        ))}
                        {filteredUsers.length === 0 && (
                            <div className="no-result">没有找到匹配的用户</div>
                        )}
                    </List>
                </div>
            </Popup>
        </div>
    );
};

export default TransferApplyPage;